export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'
export const OPEN_SIDEBAR = 'OPEN_SIDEBAR'
export const CLOSE_SIDEBAR = 'CLOSE_SIDEBAR'
